import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { RegularRate, holidayFactor, holidayRate } from 'app/models/Placement/PlacementMods';
import { HolidayFactor } from '../../PayRate/PayFactor/HolidayFactor';
import { getCalculatedAmount } from './BillOvertime';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from './BillOrientation';

export const BillHolidayTime = ({ classes, isModEdit }: { classes: any; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const billHolidayValue = useWatch({ name: holidayRate });
  const regularRateValue = useWatch<string>({ name: RegularRate });
  return (
    <Grid item className={classes.flex}>
      <Controller
        name={holidayRate}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={billHolidayValue}
            className={classes.billFactorTextfields}
            InputLabelProps={{
              shrink: getValues(holidayRate) ?? false,
            }}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                setValue(holidayRate, e.target.value);
                onChange(e.target.value);
                setValue(holidayFactor, '');
              }
            }}
            variant="filled"
            label={`${t(`placement.placementMods.${holidayRate}`)}`}
            helperText={regularRateValue ? getCalculatedAmount(getValues, holidayRate) : getInvalidAmount()}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>
                  {getValues(holidayRate) && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}
                </>
              ),
              sx: { fontSize: '14px' },
            }}
            {...rest}
          />
        )}
      />
      <div className={classes.middleText}>{'OR'}</div>
      <HolidayFactor classes={classes} currentMod={'BillRate'} isModEdit={isModEdit} />
    </Grid>
  );
};
